// obtain cookieconsent plugin
var cc = initCookieConsent();

// run plugin with config object
cc.run({
    current_lang: 'es',
    autoclear_cookies: false,                    // default: false
    cookie_name: 'efiextranet_cookies',              // default: 'cc_cookie'
    cookie_expiration: 182,                     // default: 182
    page_scripts: false,                         // default: false
    force_consent: true,                        // default: false

    // auto_language: null,                     // default: null; could also be 'browser' or 'document'
    // autorun: true,                           // default: true
    // delay: 0,                                // default: 0
    // hide_from_bots: false,                   // default: false
    // remove_cookie_tables: false              // default: false
    // cookie_domain: location.hostname,        // default: current domain
    // cookie_path: '/',                        // default: root
    // cookie_same_site: 'Lax',
    // use_rfc_cookie: false,                   // default: false
    // revision: 0,                             // default: 0

    gui_options: {
        consent_modal: {
            layout: 'cloud',                    // box,cloud,bar
            position: 'middle center',          // bottom,middle,top + left,right,center
            transition: 'zoom'                 // zoom,slide
        },
        settings_modal: {
            layout: 'box',                      // box,bar
            position: 'left',                   // right,left (available only if bar layout selected)
            transition: 'zoom'                 // zoom,slide
        }
    },

    onFirstAction: function(){
        //console.log('onFirstAction fired');
    },

    onAccept: function (cookie) {
        //console.log('onAccept fired!')
    },

    onChange: function (cookie, changed_preferences) {
        //console.log('onChange fired!');

        // If analytics category is disabled => disable google analytics
        if (!cc.allowedCategory('analytics')) {
            typeof gtag === 'function' && gtag('consent', 'update', {
                'analytics_storage': 'denied'
            });
        }
    },

    languages: {
        'es': {
            consent_modal: {
                title: 'Información de cookies',
                description: 'Este portal web únicamente utiliza cookies propias con finalidad técnica, no recaba ni cede datos de carácter general de los usuarios sin su consentimiento. <br><br> Puede encontrar toda la información en nuestra <a style="color: #2d4156" href="https://www.efidata.es/politica-de-cookies.asp" target="_blank">Política de Cookies</a>.',
                primary_btn: {
                    text: 'Aceptar todas',
                    role: 'accept_all'      //'accept_selected' or 'accept_all'
                },
                secondary_btn: {
                    text: 'Personalizar preferencias',
                    role: 'settings'       //'settings' or 'accept_necessary'
                },
                revision_message: '<br><br> Estimado usuario, los términos y condiciones han cambiado desde la última vez que nos visitó!'
            },
            settings_modal: {
                title: 'Configuración de cookies',
                save_settings_btn: 'Guardar la configuración actual', 
                accept_all_btn: 'Aceptar todas',
                reject_all_btn: 'Rechazar todas',
                close_btn_label: 'Close', //dont touch this
                cookie_table_headers: [
                    {col1: 'Nombre'},
                    {col2: 'Persistencia'},
                    {col3: 'Detalle'},
                ],
                blocks: [
                    {
                        title: '¿Qué son las cookies?',
                        description: 'Las cookies son archivos que se pueden descargar en su equipo a través de las páginas web. Son herramientas que tienen un papel esencial para la prestación de numerosos servicios de la sociedad de la información. Entre otros, permiten a una página web almacenar y recuperar información sobre los hábitos de navegación de un usuario o de su equipo y, dependiendo de la información obtenida, se pueden utilizar para reconocer al usuario y mejorar el servicio ofrecido.  <br>Más Información <a href="https://www.efidata.es/politica-de-cookies.asp" target="_blank" class="cc-link">Política de cookies</a>.'
                    },
                    {
                        title: 'Cookies estrictamente necesarias',
                        description: 'Estas cookies son necesarias para que el sitio web funcione y no se pueden desactivar en nuestros sistemas. Usualmente están configuradas para responder a acciones hechas por usted para recibir servicios, tales como ajustar sus preferencias de privacidad, iniciar sesión en el sitio, o llenar formularios. Usted puede configurar su navegador para bloquear o alertar la presencia de estas cookies, pero algunas partes del sitio web no funcionarán. Estas cookies no guardan ninguna información personal identificable.',
                        toggle: {
                            value: 'necessary',
                            enabled: true,
                            readonly: true  //cookie categories with readonly=true are all treated as "necessary cookies"
                        }
                    }, {
                        title: 'Cookies de personalización y análisis',
                        description: 'Las cookies de personalización permiten al usuario acceder al servicio con algunas características de carácter general predefinidas en función de una serie de criterios en el terminal del usuario. <br><br> Las cookies de análisis Permiten el seguimiento y análisis del comportamiento de los usuarios de los sitios web a los que están vinculadas.',
                        toggle: {
                            value: 'analytics',
                            enabled: true,
                            readonly: false
                        },
                        cookie_table: [
                            {
                                col1: '_utma',
                                col2: '2 años a partir de su instalación o actualizació',
                                col3: 'Recopila información anónima sobre la navegación de los usuarios por el sitio web con el fin de conocer el origen de las visitas y otros datos estadísticos.'
                            },
                            {
                                col1: '_utmb',
                                col2: ' 30 minutos',
                                col3: 'Almacena información sobre la actividad de la visita a nuestro sitio web y principalmente la duración de ésta.'
                            },
                            {
                                col1: '_utmc',
                                col2: 'Sesión',
                                col3: 'Almacena información sobre la actividad de la visita a nuestro sitio web y principalmente la duración de ésta.'
                            },
                            {
                                col1: '_utmz',
                                col2: '6 meses a partir de su instalación o actualización',
                                col3: 'Esta cookie normalmente se almacena en el navegador en la primera visita a nuestro sitio web.'
                            },
                            {
                                col1: '_ga',
                                col2: '2 años',
                                col3: 'Sirve para distinguir a los usuarios.'
                            },
                            {
                                col1: 'APISID',
                                col2: '2 años',
                                col3: 'Al crear o iniciar sesión en una cuenta de Google se almacenan esta cookie en su ordenador con el fin de permanecer conectado a su cuenta de Google al visitar sus servicios de nuevo. '
                            },
                            {
                                col1: 'HSID',
                                col2: '2 años',
                                col3: 'Al crear o iniciar sesión en una cuenta de Google se almacenan esta cookie en su ordenador con el fin de permanecer conectado a su cuenta de Google al visitar sus servicios de nuevo. '
                            },
                            {
                                col1: 'LOGIN_INFO',
                                col2: '2 años',
                                col3: 'En algunas páginas de nuestro Sitio Web tenemos vídeos incrustados de Youtube, es un servicio de Google.'
                            },
                            {
                                col1: 'PREF',
                                col2: '2 años',
                                col3: 'Al crear o iniciar sesión en una cuenta de Google se almacenan esta cookie en su ordenador con el fin de permanecer conectado a su cuenta de Google al visitar sus servicios de nuevo.'
                            },
                            {
                                col1: 'SAPISID',
                                col2: '2 años',
                                col3: 'En algunas páginas de nuestro Sitio Web tenemos vídeos incrustados de Youtube, es un servicio de Google.'
                            },
                            {
                                col1: 'SID',
                                col2: '2 años',
                                col3: 'Al crear o iniciar sesión en una cuenta de Google se almacenan esta cookie en su ordenador con el fin de permanecer conectado a su cuenta de Google al visitar sus servicios de nuevo.'
                            },
                            {
                                col1: 'SSID',
                                col2: '2 años',
                                col3: ' Al crear o iniciar sesión en una cuenta de Google se almacenan esta cookie en su ordenador con el fin de permanecer conectado a su cuenta de Google al visitar sus servicios de nuevo.'
                            },
                            {
                                col1: 'VISITOR_INFO1_LIVE',
                                col2: '8 meses',
                                col3: ' Al crear o iniciar sesión en una cuenta de Google se almacenan esta cookie en su ordenador con el fin de permanecer conectado a su cuenta de Google al visitar sus servicios de nuevo.'
                            },
                            {
                                col1: 'YSC',
                                col2: 'Al cerrar sesión',
                                col3: ' En algunas páginas de nuestro Sitio Web tenemos vídeos incrustados de Youtube, es un servicio de Google.'
                            },
                            {
                                col1: 'nTpXe.resume',
                                col2: '1 mes',
                                col3: 'En algunas páginas de nuestro Sitio Web tenemos vídeos incrustados de Youtube, es un servicio de Google.'
                            },
                            {
                                col1: 'AMP_TOKEN',
                                col2: '30 segundos a 1 año',
                                col3: 'Incluye un token que se puede utilizar para recuperar un ID de cliente del servicio de ID de cliente de AMP.'
                            },
                            {
                                col1: '_gac_',
                                col2: '90 días',
                                col3: 'Incluye información de la campaña relativa al usuario. Si has vinculado tus cuentas de Google Analytics y AdWords, las etiquetas de conversión de sitios web leerán esta cookie, a menos que la inhabilites.'
                            }
                        ]
                    }, {
                        title: 'Cookies publicidad comportamental',
                        description: 'Almacenan información del comportamiento de los usuarios obtenida a través de la observación continuada de sus hábitos de navegación, lo que permite desarrollar un perfil específico para mostrar publicidad en función del mismo.',
                        toggle: {
                            value: 'targeting',
                            enabled: true,
                            readonly: false,
                            reload: 'on_disable'            // New option in v2.4, check readme.md
                        },
                        cookie_table: [
                            {
                                col1: '_gat',
                                col2: '1 minuto',
                                col3: 'Utilizada para mostrar nuestra publicidad en otras páginas de la red de Google. Generada por Google Analytics.'
                            },
                            {
                                col1: '_gid',
                                col2: '24 horas',
                                col3: ' Generada por Google Analytics.'
                            }
                        ]
                    }, {
                        title: 'Más Infomación',
                        description: 'Para mas información sobre nuestra politica de cookies nos puedes enviar un correo a <a class="cc-link" href="mailto:info@efidata.es">info@efidata.es</a>',
                    }
                ]
            }
        }
    }
});